var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"caption mr-2"},[_vm._v("Try:")]),_vm._l((_vm.ideas),function(idea,i){return _c('v-chip',{key:idea,staticClass:"mr-2 mb-2",attrs:{"small":"","label":"","outlined":""},on:{"click":function($event){return _vm.$emit('select', idea)}}},[_vm._v(" "+_vm._s(idea)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }